import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import WorkingAdmin from './pages/WorkingAdmin';
import PublicApp from './PublicApp';
import { LanguageProvider } from './contexts/LanguageContext';
import type { PublicPageData } from './lib/publicPage';

interface AppProps {
  initialData?: PublicPageData | null;
}

const App: React.FC<AppProps> = ({ initialData }) => (
  <LanguageProvider initialData={initialData}>
    <Router>
      <PublicApp initialData={initialData} adminElement={<WorkingAdmin />} />
    </Router>
  </LanguageProvider>
);

export default App;
